module.exports = __webpack_public_path__ + "img/visa.3539229e.svg";